import { get } from '../base';

import { CollectionParams, CollectionResponse } from './types';

export function getSharedCollections(params?: CollectionParams): Promise<CollectionResponse> {
  return get('v5/pos/collections', { searchParams: params }).json();
}
